import { Button, Form, InputFieldRhf, XStack, Error, colors, YStack } from '@my/ui'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import * as z from 'zod'
import { zodEmailValidator } from 'app/utils/zod-email-validator'

const formSchema = z.object({
  email: z.string().refine(zodEmailValidator, { message: 'Invalid email' }),
  password: z.string(),
})

export type LogInFormValues = z.infer<typeof formSchema>

export interface LogInFormProps {
  loading: boolean
  error?: string
  onSubmit: (values: LogInFormValues) => void
}

export const LogInForm = (props: LogInFormProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: '',
      password: '',
    },
  })

  return (
    <Form
      gap="$3"
      w="100%"
      onSubmit={handleSubmit((data) => {
        props.onSubmit(data)
      })}
    >
      <InputFieldRhf
        name="email"
        control={control}
        label="Email"
        placeholder="Your email"
        inputMode="email"
        hideLabel
        required
        autoComplete="email"
      />

      <InputFieldRhf
        name="password"
        control={control}
        label="Password"
        isPassword
        placeholder="Your password"
        hideLabel
        required
        autoComplete="password"
      />

      {props.error && (
        <YStack px="$3" py="$2" borderRadius={4} borderWidth={1} borderColor="$red11">
          <Error error={props.error} />
        </YStack>
      )}
      {(errors.email?.message || errors.password?.message) && (
        <YStack px="$3" py="$2" borderRadius={4} borderWidth={1} borderColor="$red11">
          {errors.email?.message && <Error error={errors.email.message}></Error>}

          {errors.password?.message && <Error error={errors.password.message}></Error>}
        </YStack>
      )}

      <XStack gap="$3" w="100%">
        <Form.Trigger asChild fd="row" ai="center">
          <Button w="100%" theme="primary" size="$4" fontSize="$5" loading={props.loading}>
            Log In
          </Button>
        </Form.Trigger>
      </XStack>
    </Form>
  )
}
